import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
  WalletIcon,
} from '@heroicons/react/24/outline';
import { BellAlertIcon } from '@heroicons/react/24/solid';
import { WalletUserDto } from '../../../../../interfaces/user/verification-steps/wallet-user.dto';
import IconTitleItem from '../../../../IconTitleItem/IconTitleItem';
import VerificationStepsConfigDto from '../../../../../interfaces/VerificationStepsConfig.dto';
import { getWalletProtocolName } from '../../../../../utils/Wallet.util';

interface WalletDataProps {
  wallet: WalletUserDto;
  config?: VerificationStepsConfigDto;
}

const WalletData = ({ wallet, config }: WalletDataProps) => {
  if (config?.wallet?.receivingWallet) {
    return (
      <div className='grid gap-5 grid-cols-3'>
        {wallet.walletAddress && (
          <>
            <IconTitleItem
              icon={<ArrowRightCircleIcon />}
              title='Sending Protocol'
              subTitle={getWalletProtocolName(wallet.walletProtocol)}
            />
            <div className='col-span-2'>
              <IconTitleItem
                icon={<ArrowRightCircleIcon />}
                title='Sending Address'
                subTitle={wallet.walletAddress}
              />
            </div>
          </>
        )}

        {wallet.receivingWalletAddress && (
          <>
            <IconTitleItem
              icon={<ArrowLeftCircleIcon />}
              title='Receiving Protocol'
              subTitle={getWalletProtocolName(wallet.receivingWalletProtocol)}
            />
            <div className='col-span-2'>
              <IconTitleItem
                icon={<ArrowLeftCircleIcon />}
                title='Receiving Address'
                subTitle={wallet.receivingWalletAddress}
              />
            </div>
          </>
        )}
      </div>
    );
  }

  return (
    <div className='grid gap-5 grid-cols-2'>
      <IconTitleItem
        icon={<WalletIcon />}
        title='Wallet Address'
        subTitle={wallet.walletAddress}
      />
      {wallet.risk && (
        <IconTitleItem
          icon={<BellAlertIcon />}
          title='Risk'
          subTitle={wallet.risk}
        />
      )}
      {wallet.riskReason && (
        <IconTitleItem
          icon={<BellAlertIcon />}
          title='Risk Reason'
          subTitle={wallet.riskReason}
        />
      )}

      {/* {wallet.walletAddress && (
        <IconTitleItem
          icon={<BellAlertIcon />}
          title="Link to details"
          subItem={
            <a
              target="_blank"
              className="text-sm underline text-primary"
              href={`https://kyt.chainalysis.com/entities/${wallet.walletAddress}`}
            >
              Open
            </a>
          }
        />
      )} */}
    </div>
  );
};

export default WalletData;
